import { apiClient } from "@/services/apiClient";
import type { DashboardSummaryDto } from "@/types/dashboard";

export async function getDashboardSummary(): Promise<DashboardSummaryDto> {
  const res = await apiClient.get<DashboardSummaryDto>("/api/dashboard/home");
  return res.data;
}

export async function getInsights() {
  try {
    const res = await apiClient.get("/api/dashboard/insights");
    return res.data;
  } catch (error) {
    console.error("Failed to fetch insights:", error);
    return null;
  }
}

export async function unfollowSite(siteId: string): Promise<{ success: boolean; error?: string }> {
  try {
    await apiClient.delete(`/api/dashboard/followed-sites/${siteId}`);
    return { success: true };
  } catch (error: any) {
    console.error("Failed to unfollow site:", error);
    const errorMessage = error?.response?.data?.error || "Failed to unfollow site";
    return { success: false, error: errorMessage };
  }
}

export async function markTaskComplete(taskId: string, taskTitle?: string): Promise<void> {
  await apiClient.patch(`/api/planner/tasks/${taskId}/complete`, {
    taskTitle: taskTitle || ""
  });
}

export async function getActivityLog(): Promise<any[]> {
  try {
    console.log('[getActivityLog] Calling /api/activitylog...');
    const res = await apiClient.get("/api/activitylog");
    console.log('[getActivityLog] Response:', res.data?.length, 'items');
    return res.data;
  } catch (error) {
    console.error("[getActivityLog] Failed to fetch activity log:", error);
    return [];
  }
}